import React, { useState, useRef, useEffect } from 'react';
import '../../styles/group-chat-brutal.css';

/**
 * Chat message input component
 * Brutal design style with auto-expanding textarea
 */
const ChatMessageInput = ({
  onSend,
  disabled = false,
  placeholder = 'Type a message...',
  maxLength = 2000
}) => {
  const [message, setMessage] = useState('');
  const [rateLimited, setRateLimited] = useState(false);
  const textareaRef = useRef(null);

  // Auto-resize textarea
  useEffect(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = 'auto';
      textarea.style.height = Math.min(textarea.scrollHeight, 120) + 'px';
    }
  }, [message]);

  // Handle submit
  const handleSubmit = (e) => {
    e?.preventDefault();

    if (!message.trim() || disabled || rateLimited) return;

    onSend(message);
    setMessage('');

    // Reset textarea height
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
    }
  };

  // Handle key press
  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

  // Handle input change
  const handleChange = (e) => {
    const value = e.target.value;
    if (value.length <= maxLength) {
      setMessage(value);
    }
  };

  const charCount = message.length;
  const nearLimit = charCount > maxLength * 0.8;
  const isDisabled = disabled || rateLimited || !message.trim();

  return (
    <div className="chat-input-container">
      {rateLimited && (
        <div className="chat-rate-limit">
          Please wait before sending more messages
        </div>
      )}

      <form onSubmit={handleSubmit} className="chat-input-wrapper">
        <textarea
          ref={textareaRef}
          className="chat-input"
          value={message}
          onChange={handleChange}
          onKeyPress={handleKeyPress}
          placeholder={placeholder}
          disabled={disabled}
          rows={1}
          aria-label="Message input"
        />

        <button
          type="submit"
          className="chat-send-btn"
          disabled={isDisabled}
          aria-label="Send message"
        >
          {disabled ? '...' : '→'}
        </button>
      </form>

      {nearLimit && (
        <div className="chat-input-hint">
          {charCount}/{maxLength} characters
        </div>
      )}
    </div>
  );
};

export default ChatMessageInput;
